import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { LoaderIcon } from "lucide-react";
import Footer from '../components/Footer';
import axios from '../api/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add('login-page');
    return () => {
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post('/forgot-password', { email });
      
      toast.success(response.data.message);
      setLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.error || "An error occurred");
      setLoading(false);
    }
  };

  return (
    <>
    <div className="p-4 flex flex-col items-start max-w-sm mx-auto h-dvh overflow-hidden pt-20 mb-20">
      {loading && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-background/80 z-50">
          <LoaderIcon className="w-5 h-5 animate-spin" />
        </div>
      )}
     
      <div className="flex items-center w-full py-8 border-b border-border/80">
        <a href="/" className="flex items-center">
          <img
            src={`${process.env.REACT_APP_URL}/images/omahlogoupdated.png`}
            alt="Omah Global"
            className="h-8 w-auto object-contain"
          />
        </a>
      </div>

      <div className="flex flex-col items-start gap-y-6 py-8 w-full px-0.5">
        <h2 className="text-2xl font-semibold">
          Forgot Password
        </h2>
        <p className="text-sm text-muted-foreground">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} className="w-full">
          <div className="space-y-2 w-full">
            <Label htmlFor="email">
              Email
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              disabled={loading}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full focus-visible:border-foreground"
            />
          </div>

          <div className="mt-4 w-full">
            <Button
              type="submit"
              disabled={loading}
              className="w-full"
            >
              {loading ? (
                <LoaderIcon className="w-5 h-5 animate-spin" />
              ) : "Reset Password"}
            </Button>
          </div>
        </form>
      </div>

      <div className="flex items-start mt-auto border-t border-border/80 py-6 w-full">
        <p className="text-sm text-muted-foreground">
          Remember your password?{" "}
          <a href="/login" className="text-primary">
            Back to Login
          </a>
        </p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default ForgotPassword;